import type { EntityGraphNode } from "../engine/EntityGraphNode/EntityGraphNode.type"
import { EntityTypeId, type HasEntityTypeId } from "./EntityTypeId.enum"
import type { Entity } from "./index"
import type { UnitEntityUnion } from "./UnitEntityUnion.type"

function isEntityUnit<T extends EntityGraphNode>(
  entity: T
): entity is T & EntityGraphNode<UnitEntityUnion>

function isEntityUnit(
  entity: Entity
): entity is UnitEntityUnion

function isEntityUnit<T extends HasEntityTypeId> (
  entity: T
): entity is T & {etype_id: UnitEntityUnion['etype_id']} {
  return entity.etype_id >= EntityTypeId.Infantry
}

export default isEntityUnit
